import { mapStressLevelToCategory } from '../api/stressCheckApi';
/**
 * Maps API stress data to participant stress data
 *
 * @param {IStressCheckData[]} apiData - Raw API data
 * @returns {Map<string, IParticipantStressData>} Mapped participant stress data
 */
export function mapApiDataToParticipantStress(apiData) {
    const participantStressMap = new Map();
    // If we have stress data, use the latest one
    if (apiData.length > 0) {
        const latestData = apiData[0]; // API returns only the latest stress level
        // The stress level is stored in the 'item' field
        const stressLevel = latestData.item;
        // Extract numeric stress level from item if it contains a number
        // For now, we'll use a simple mapping since item contains strings like 'test_item_3'
        let numericLevel = 1; // Default to medium
        const match = stressLevel.match(/\d+/);
        if (match) {
            numericLevel = parseInt(match[0], 10);
        }
        const stressCategory = mapStressLevelToCategory(numericLevel);
        console.log('stressCategory', stressCategory);
        // Store this as a global stress level that will be applied to all participants
        participantStressMap.set('global', {
            participantId: 'global',
            stressLevel: stressLevel,
            stressCategory,
            lastUpdated: latestData.timestamp || null
        });
    }
    return participantStressMap;
}
/**
 * Gets stress data for a specific participant
 *
 * @param {Map<string, IParticipantStressData>} stressMap - Stress data map
 * @param {string} participantId - Participant ID
 * @returns {IParticipantStressData | null} Participant stress data or null
 */
export function getParticipantStressData(stressMap, participantId) {
    return stressMap.get(participantId) || null;
}
/**
 * Gets stress category for a participant (with fallback to default)
 * Since all participants share the same stress level, we return the global stress level
 *
 * @param {Map<string, IParticipantStressData>} stressMap - Stress data map
 * @param {string} participantId - Participant ID (not used since we have global stress)
 * @param {string} defaultCategory - Default category if no data found
 * @returns {string} Stress category
 */
export function getParticipantStressCategory(stressMap, participantId, defaultCategory = 'medium') {
    // Get the global stress data that applies to all participants
    const globalStressData = stressMap.get('global');
    return globalStressData ? globalStressData.stressCategory : defaultCategory;
}
